import React from 'react';
import { useIntl } from 'react-intl';
import StatsCard from './StatsCard';
import useTenantStats from '../../hooks/useTenantStats/useTenantStats';
import statsContainerMessages from './messages';

import './StatsContainer.scss';

const { getConfig } = require('@edx/frontend-platform');

/**
 * React function component that displays multiple feedback card components in a row. The
 * number of cards per row depends on the window width, and the content is retrieved from
 * the public feedback API.
 *
 * @return {JSX.Element}               React element.
 */
function StatsContainer({
  showCourses, showInstructors, showLearners, showVideos, showProblems, showCertificates,
}: {
  showCourses: boolean,
  showInstructors: boolean,
  showLearners: boolean,
  showVideos: boolean,
  showProblems: boolean,
  showCertificates: boolean,
}): JSX.Element {
  const intl = useIntl();
  const { STATS_SETTINGS } = getConfig();
  const {
    courses,
    instructors,
    learners,
    videos,
    problems,
    certificates,
  } = useTenantStats();

  return (
    <div className="stats-container">
      <div>
        <h4>{intl.formatMessage(statsContainerMessages.title)}</h4>
      </div>

      <div className="stats">
        {showCourses
          && (
          <StatsCard
            title={intl.formatMessage(statsContainerMessages.courses)}
            imageUrl={STATS_SETTINGS?.COURSE_IMAGE_URL}
            count={courses}
          />
          )}
        {showInstructors
          && (
          <StatsCard
            title={intl.formatMessage(statsContainerMessages.instructors)}
            imageUrl={STATS_SETTINGS?.INTRUCTOR_IMAGE_URL}
            count={instructors}
          />
          )}
        {showLearners
          && (
          <StatsCard
            title={intl.formatMessage(statsContainerMessages.learners)}
            imageUrl={STATS_SETTINGS?.LEARNER_IMAGE_URL}
            count={learners}
          />
          )}
        {showVideos
          && (
          <StatsCard
            title={intl.formatMessage(statsContainerMessages.videos)}
            imageUrl={STATS_SETTINGS?.VIDEO_IMAGE_URL}
            count={videos}
          />
          )}
        {showProblems
          && (
          // The message has been changed, however this stat still shows problem metric.
          <StatsCard
            title={intl.formatMessage(statsContainerMessages.courseUnits)}
            imageUrl={STATS_SETTINGS?.PROBLEM_IMAGE_URL}
            count={problems}
          />
          )}
        {showCertificates
          && (
          <StatsCard
            title={intl.formatMessage(statsContainerMessages.certificates)}
            imageUrl={STATS_SETTINGS?.CERTIFICATE_IMAGE_URL}
            count={certificates}
          />
          )}
      </div>
    </div>
  );
}

export default StatsContainer;
